import type { PropsWithChildren } from "react";
import { twMerge as tw } from "tailwind-merge";

import type { Styled } from "~/utils";

interface IconWrapperProps extends PropsWithChildren<Styled> {
  size?: "sm" | "md" | "lg" | "xl";
  style?: React.CSSProperties;
}

export const IconWrapper = ({
  size = "md",
  className,
  style,
  children,
}: IconWrapperProps) => (
  <div
    className={tw(
      "flex flex-row items-center",
      size === "sm" && "h-5 w-5",
      size === "md" && "h-6 w-6",
      size === "lg" && "h-6 w-6",
      size === "xl" && "h-10 w-10",
      className,
    )}
    style={style}
  >
    {children}
  </div>
);
